// LS-1324/LS-1754: verify cookies

function mVerifyUserCookies() {
  return setTimeout(() => {
    const src = '/verify_cookies';
    // test if verification was already done in current session
    if (sessionStorage && window.sessionStorage.getItem('verifiedCookies')) {
      return;
    }
    const el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      sessionStorage && sessionStorage.setItem('verifiedCookies', 'true');
    } catch (error) {}
  }, 0);
}

module.exports = mVerifyUserCookies;
